import { render, staticRenderFns } from "./Wp_tb_select.vue?vue&type=template&id=12a4b0ea&scoped=true&"
import script from "./Wp_tb_select.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_select.vue?vue&type=script&lang=js&"
import style0 from "./Wp_tb_select.vue?vue&type=style&index=0&id=12a4b0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a4b0ea",
  null
  
)

export default component.exports